<template>
  <div class="air_con">
    <div class="content c895">
      <h2>Dodajte Klimatsko napravo</h2>
    </div>
    <div class="content c590">
      <div class="popup popDev7" style="display:none;">
        <div class="inner">
          <h3></h3>
          <div class="msg">
            <h3>Izpolniti je potrebno vsaj eno polje za pogostost uporabe naprave!</h3>
          </div>

          <div class="btns">
            <a href="javascript:void(0)" class="btn" title="OK" onclick="popupDelete()">V REDU</a>
          </div>
        </div>
      </div>
      <div class="form">
        <h3>VPIŠITE PODATKE O KLIMATSKI NAPRAVI</h3>
        <div class="f-item select">
          <label>
            Hladilna moč (kW):
            <span
              id
              style="color:Red;float:none;font-size:1em;visibility:hidden;"
            >*</span>
            <span id style="color:Red;float:none;font-size:1em;visibility:hidden;">*</span>
            <span></span>
          </label>
          <input name type="text" id />
          <!-- tooltip + div added-->
          <div class="help">
            <a href="#" class="help" title="Help">Help</a>
            <div class="tooltip">Vnesite ustrezno hladilno moč vaše klimatske naprave.</div>
          </div>
          <!-- //end -->
        </div>
        <div class="f-item select">
          <label>
            Grelna moč (kW):
            <span id style="color:Red;float:none;font-size:1em;visibility:hidden;">*</span>
            <span id style="color:Red;float:none;font-size:1em;visibility:hidden;">*</span>
            <span></span>
          </label>
          <input name type="text" id />
          <!-- tooltip + div added-->
          <div class="help">
            <a href="#" class="help" title="Help">Help</a>
            <div class="tooltip">Vnesite ustrezno grelno moč vaše klimatske naprave.</div>
          </div>
          <!-- //end -->
        </div>
        <div class="f-item select">
          <label>
            Faktor učinkovitosti hlajenja - EER:
            <span
              id
              style="color:Red;float:none;font-size:1em;visibility:hidden;"
            >*</span>
            <span id style="color:Red;float:none;font-size:1em;visibility:hidden;">*</span>
            <span></span>
          </label>
          <input name type="text" id />
        </div>
        <div class="f-item select">
          <label>
            Faktor učinkovitosti gretja - COP:
            <span
              id
              style="color:Red;float:none;font-size:1em;visibility:hidden;"
            >*</span>
            <span id style="color:Red;float:none;font-size:1em;visibility:hidden;">*</span>
            <span></span>
          </label>
          <input name type="text" id />
        </div>
      </div>
      <div class="question">
        <p>Koliko ur na leto uporabljate klimatsko napravo?</p>
        <div class="help">
          <a href="#" class="help" title="Help">Help</a>
          <div
            class="tooltip"
          >Na porabo elektrike in višino računa vpliva tarifa, v kateri uporabljate klimo ter moč in faktor učinkovitosti naprave. Manjša tarifa velja med tednom ponoči (od 22.00 do 6.00) ter ob sobotah, nedeljah ter dela prostih dnevih cel dan.</div>
        </div>
      </div>
      <div class="answer-list">
        <ul>
          <li class="first">
            <div>za hlajenje</div>
            <div>za gretje</div>
          </li>
          <li class="answer odd">
            <span class="small">št. ur</span>
            <div>
              <input name type="text" id />
              <span>ur</span>
            </div>
            <div class="last">
              <input name type="text" id />
              <span>ur</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="add">
        <input type="submit" name value="Dodaj" @click="addedApplianceNum(11)" />
      </div>
    </div>
    <div class="content r-c">
      <div class="c282 info">
        <h3>INFO O KLIMATSKI NAPRAVI</h3>
        <p>Klimatska naprava, ki je uvrščena v energetski razred A, se lahko od modela do modela pri porabi razlikuje tudi za več kot 60 odstotkov. Zato moramo biti pozorni na izkoristke pri hlajenju (EER) in pri gretju (COP). Klimatska naprava pridobi razred hlajenja A pri izkoristku (EER), ki je višji od 3,2 in razred gretja A pri izkoristku (COP), ki je višji od 3,6.</p>

        <div class="average">
          <h4>Povprečna poraba tipične klimatske naprave na leto</h4>
          <span>450 kWh/leto</span>
          <p>
            <strong>33.97 € / leto</strong> (enotarifno)
            <br />
            <strong>29.13 € / leto</strong> (dvotarifno)
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    addedApplianceNum(x) {
      console.log('From air con');
      this.$emit('applianceFormClicked', x);
    },
  },
};
</script>

<style>
</style>